/*
 * @Author: qhy
 * @Date: 2022-04-28 09:17:02
 * @LastEditors: qhy
 * @LastEditTime: 2022-04-28 11:09:53
 * @Description: 坐标点经纬度的度分秒字符串和十进制/数组之间的转换
 */
   
/**
     * 度分秒转十进制
     * @param dfm
     * @returns {number}
     */
function convertGPSToXY(dfm) {
    const arr1 = dfm.split('°');
    const d = arr1[0];
    const arr2 = arr1[1].split("'")
    let f = arr2[0] || 0;
    const m = arr2[1].replace('"', '') || 0;
    f = parseFloat(f) + parseFloat(m / 60);
    let du = parseFloat(f / 60) + parseFloat(d);
    return du;
}

/**
 * 十进制转度分秒
 * @param point
 * @returns {*}
 */
function convertXYToGPS(point) {

    let xy;
    if (point instanceof Array) {
        xy = point;
    } else {
        point = point + "";
        xy = point.split(',');
    }

    let dPoint = [];
    let dPointStr = "";
    for (let i = 0; i < xy.length; i++) {
        const mElement = xy[i] + "";
        const arr1 = mElement.split(".");
        const d = arr1[0];
        let tp = "0." + (arr1[1] || '0');
        tp = String(tp * 60); //这里进行了强制类型转换
        const arr2 = tp.split(".");
        const f = arr2[0];
        tp = "0." + (arr2[1] || '0');
        tp = tp * 60;
        const m = tp.toFixed(2);
        const dfm = d + "°" + f + "'" + m + "\"";
        dPointStr += "," + dfm;
        dPoint.push(dfm);
    }

    dPointStr = dPointStr.replace(',', '');

    return point instanceof Array ? dPoint : dPointStr;
}


/**
 * @Author: qhy
 * @LastEditors: qhy
 * @Date: 2022-04-28 10:36:55
 * @description: 将度分秒字符串转换成数组
 * @param {*} dfm
 * @return {*}
 */
function convertGPSToArray(dfm) {
    const arr1 = dfm.split('°');
    const d = arr1[0];
    const arr2 = arr1[1].split("'")
    const f = arr2[0] || 0;
    const m = arr2[1].replace('"', '') || 0;
    return [d, f, m];
}
/**
 * @Author: qhy
 * @Date: 2022-04-28 11:03:32
 * @LastEditors: qhy
 * @Description: 将数组转换成度分秒字符串
 * @param {*} arr
 * @return {*}
 */
function convertArrayToGPS(arr) {
    let dfm = `${arr[0] || '0'}°${arr[1] || '0'}'${arr[2] || '0'}"`
    return dfm;
}
export { convertGPSToXY, convertXYToGPS, convertGPSToArray, convertArrayToGPS }